"use strict";
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, upload, Flash) {
  $scope.doBulkUpload = function() {
    $scope.loading = true;
    upload({
      url: '/api/attachment/bulkimport',
      method: 'POST',
      data: {}
    }).then(function(response) {
      var message = '<strong>Erfolgreich importiert!</strong>.';
      Flash.create('success', message, 5000, {}, true);
      $scope.loading = false;
      $scope.getBulkFiles();
    }, function(response) {
      var msg = "Unkown";
      if (hlp.isSet(response.data.message)) {
        msg = response.data.message;
      }
      var message = '<strong>Fehler beim importieren! (' + msg + ')</strong>.';
      Flash.create('danger', message, 0, {}, true);
      $scope.loading = false;
      $scope.getBulkFiles();
    });
  };
  $scope.getBulkFiles = function() {
    $scope.loading = true;
    $scope.bulkFiles = [];
    $scope.bulkFileCount = 0;
    $http.get('/api/attachment/bulkfiles.json').then(function(response) {
      if (response.data.files !== undefined && response.data.files.length > 0) {
        $scope.bulkFiles = response.data.files;
        $scope.bulkFileCount = response.data.files.length;
      }
    }, function(response) {
      var message = '<strong>Fehler bei der Dateisuche!</strong>.';
      Flash.create('danger', message, 0, {}, true);
    });
    $scope.loading = false;
  };
  var init = function() {
    $scope.bulkFiles = [];
    $scope.bulkFileCount = 0;
    $scope.getBulkFiles();
  }();
};
module.exports = controller;
